'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'circle-user';
var width = 512;
var height = 512;
var aliases = [62142,"user-circle"];
var unicode = 'f2bd';
var svgPathData = ['M0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zM120.1 391.6l23.9-71.6 224 0 23.9 71.6C357.1 426.5 309.1 448 256 448s-101.1-21.5-135.9-56.4zM328 200a72 72 0 1 1 -144 0 72 72 0 1 1 144 0z', 'M256 448c53.1 0 101.1-21.5 135.9-56.4l-23.9-71.6-224 0-23.9 71.6C154.9 426.5 202.9 448 256 448zm0-176a72 72 0 1 0 0-144 72 72 0 1 0 0 144z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleUser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;